<script lang="ts">
	import SideFull from "./SideFull.svelte";

	import Terminal from "../actions/Termina.svelte";
	import Settings from "../settings/settings.svelte";
	import Support from "../actions/Support.svelte";

	import { RoutinchInfo, UserCredential } from "../script/store";
	import { routingInfo } from "../script/common";
	import { slide } from "svelte/transition";
	import Mesurment from "../mesurment/Mesurment.svelte";
	import AsistentCrossroads from "../managment/AsistentCrossroads.svelte";
	import { APP_VERSION } from "../version";
	import BigTable from "../other/BigTable.svelte";

	/* let showTerminal = false;
	let showMesurment = true;
	let showSetting = true;
	let showSesionManagment = true;
	let showMesurmentManagment = true;
	let showSupport = true; */

	let showTerminal = false;
	let showMesurment = false;
	let showSetting = false;
	let showSesionManagment = false;
	let showMesurmentManagment = false;
	let showSupport = false;

	UserCredential.subscribe((userData) => {
		if (userData) {
			userData.roleInfo.activeDialogs.forEach((enabledRoutingInfo) => {
				/* if (routingInfo.SUPPORT.id !== enabledRoutingInfo.id) {
					
				} */
				togleRouting(enabledRoutingInfo);
			});
			RoutinchInfo.setAll(userData.roleInfo.activeDialogs);
		} else {
			resetRoutingInfo();
		}
	});
	RoutinchInfo.subscribeUpdate((info) => {
		togleRouting(info);
	});
	function togleRouting(info) {
		if (!info) {
			return;
		} else if (routingInfo.TERMINAL.id === info.id) {
			showTerminal = !showTerminal;
		} else if (routingInfo.MESURMENT.id === info.id) {
			showMesurment = !showMesurment;
		} else if (routingInfo.SETINGS.id === info.id) {
			showSetting = !showSetting;
		} else if (routingInfo.MESURMENT_INFO.id === info.id) {
			showMesurmentManagment = !showMesurmentManagment;
		} else if (routingInfo.SESSION_INFO.id === info.id) {
			showSesionManagment = !showSesionManagment;
		} else if (routingInfo.SUPPORT.id === info.id) {
			showSupport = !showSupport;
		} else {
			console.log("Unknown routing", info);
		}
	}
	function resetRoutingInfo() {
		showTerminal = false;
		showMesurment = false;
		showSetting = false;
		showSesionManagment = false;
		showMesurmentManagment = false;
		showSupport = false;
	}
</script>

<SideFull>
	<div class="rightWorkpace">
		<div class="content">
			<div class="functions">
				<div class="cRec" class:cRecActive={showSetting}>
					<Settings />
				</div>
				<!-- 				{#if showTerminal}
					<div transition:slide>
						<Terminal />
					</div>
				{/if} -->
				<div class="cRec" class:cRecActive={showSesionManagment}>
					<div transition:slide>
						<!-- <SesionsManagment /> -->
						<AsistentCrossroads />
					</div>
				</div>
				<div class="cRec" class:cRecActive={showMesurmentManagment}>
					<div transition:slide>
						<BigTable />
					</div>
				</div>

				<div class="cRec" class:cRecActive={showMesurment}>
					<div transition:slide>
						<!-- <ValMonitor /> -->

						<Mesurment />
					</div>
				</div>

				<div class="cRec" class:cRecActive={showSupport}>
					<div transition:slide>
						<Support />
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="footer">
		<p>App version: {APP_VERSION}</p>
	</div>
</SideFull>

<style>
	.cRec {
		position: relative;
		left: calc(-100% + -4rem);
		top: -2rem;
		max-height: 0;
		/* max-height: 0;
	height: 0; */
		/* transition: all 3s linear; */
		transition: all 0.4s cubic-bezier(0.62, 0.43, 0.55, 1.09);
		transform: scale(0.1);
	}
	.cRecActive {
		left: 0;
		top: 0;
		transform: scale(1);
		/* height: auto;
	max-height: 100000px; */
		max-height: 1000000vh;
		/* max-height: none; */
	}
	.rightWorkpace {
		min-height: 100%;
		display: grid;
		grid-template-rows: auto 1fr;
	}

	.content {
		padding: 1.5rem 3rem;
		position: relative;
	}
	.footer {
		/* position: absolute;
		bottom: 0;
		left: 0;
		right: 0; */
		margin-top: auto;
		background: #f5f5f5;
		padding: 0 15px 5px 15px;
	}
	.footer {
		text-align: end;
		font-size: 0.9rem;
		color: #aaa;
	}
</style>
